<template>
  <div class="addAnswerWrapper">
    <div class="btnBox clearfix">
      <a href="javascript:void(0);" class="fl" @click="closeText">取消</a>
      <a href="javascript:void(0);" class="fr" @click="addText">保存</a>
    </div>
    <quill-editor
      :class="['qustionCount']"
      id="qustionCount"
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      @change="onEditorChange($event)"
      :style="{height:contentHeight +'px'}"
    ></quill-editor>
  </div>
</template>

<script>
/* eslint-disable */
import { getDeviceType ,getTextImgUrl} from "@/common/getDeviceType/getDeviceType";
const toolbarOptions = [
  [{ size: ["small", false, "large", "huge"] }],
  [{ color: [] }],
  ["bold"], // toggled buttons
  [{ align: [] }],
  ["image"] // remove formatting button
];
export default {
  name: "addText",
  props: {
    textSource: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      initialContent: "",
      content: "",
      intro: "",
      contentHeight: 0,
      curreIndex: "",
      Number: "",
      addType: "", //是addType否可以提交

      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function(value) {
                if (value) {
                  getTextImgUrl();
                } else {
                  this.quill.format("image", false);
                }
              }
            }
          }
        }
      }
    };
  },
  mounted() {
    
    window.setTextImgs=  this.setImgUrl;
    this.clientType = getDeviceType();
    this.editorResize();
    window.addEventListener("resize", this.editorResize);
  },
  methods: {
    onEditorChange() {}, // 内容改变事件
    // getImgUrl() {
    //   //调用相册或拍照
    //   if (this.clientType == "android") {
    //     //安卓
    //     window.android.getInfo(103, "");
    //   } else {
    //     //IOS
    //     window.webkit.messageHandlers.getImgs.postMessage(null);
    //   }
    // },
    setImgUrl(iosImg) {
      let _this = this;
      let imgurl = ""; //获取上传后的图片相关信息
      if (this.clientType == "android") {
        imgurl = JSON.parse(window.android.getInfo(104, ""));
      } else {
        imgurl = JSON.parse(iosImg);
      }
      let quill = this.$refs.myQuillEditor.quill;
      // 获取光标所在位置
      let length = quill.getSelection().index;
      // 插入图片  res.info为服务器返回的图片地址
      quill.insertEmbed(length, "image", imgurl.url);
      // 调整光标到最后
      quill.setSelection(length + 1);
    },
    sliceIntro(text) {
      text = text.replace(/(\n)/g, "");
      text = text.replace(/(\t)/g, "");
      text = text.replace(/(\r)/g, "");
      text = text.replace(/<\/?[^>]*>/g, "");
      text = text.replace(/\s*/g, "");
      if (text.length > 200) {
        text = text.substr(0, 200);
        this.intro = text;
      } else {
        this.intro = text;
      }
    },
    addText() {
      let setData = {};
      setData.count = this.content;
      setData.index = this.curreIndex;
      setData.Number = this.Number + 1;
      this.$emit("getData", setData);
    },
    closeText() {
      let setData = {};
      setData.count = this.initialContent;
      setData.index = this.curreIndex;
      setData.Number = this.Number + 1;
      this.$emit("getData", setData);
      this.content = this.initialContent;
    },
    //监听页面高度变化
    editorResize() {
      let CHeight = document.body.clientHeight;
      this.contentHeight = CHeight - 90;
    }
  },

  watch: {
    textSource: {
      handler(newVal) {
        this.initialContent = newVal.count;
        this.content = newVal.count;
        this.curreIndex = newVal.index;
        this.Number = newVal.Number;
      },
      immediate: true,
      deep: true
    }
  },
  //关闭页面时销毁监听事件
  beforeDestroy() {
    window.removeEventListener("resize", this.editorResize); // 通过有名函数 解除事件订阅
  }
};
</script>

<style lang="less">
@import "./css/addText.less";
</style>